<template>
  <div class="navigation-button">
    <div class="button-content" v-on:click="onClick">
      <slot/>
      <span class="button-text">
        <span v-if="showNewBadge" class="is-new-banner">חדש!</span>
        {{ buttonText }}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavigationButton',
  props: {
    onClick: {
      type: Function,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    showNewBadge: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .navigation-button {
    height: 60px;
    margin: 0px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;

    .button-content {
      height: 100%;
      display: flex;
      align-items: center;

      .button-text {
        margin-right: 14px;
        position: relative;
        .is-new-banner {
          @include is-new-banner;
        }
      }
    }
  }
</style>
